(function () {
  if (customElements.get('ce-custom-field-select') !== undefined) {
    return;
  }

  class CustomFieldSelect extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        input: '[data-custom-field-select-input]',
        required: '[data-custom-field-select-required]',
      };

      this.elements = null;

      this._handleChange = this._handleChange.bind(this);
    }

    parsedCallback() {
      this.elements = {
        input: this.querySelector(this.selectors.input),
        required: this.querySelector(this.selectors.required),
      };

      this.elements.input.addEventListener('change', this._handleChange);
    }

    disconnectedCallback() {
      this.elements.input.removeEventListener('change', this._handleChange);
    }

    _handleChange(event) {
      if (event.target.value !== '') {
        this.elements.required?.classList.add('opacity-0');
      } else {
        this.elements.required?.classList.remove('opacity-0');
      }
    }
  }

  customElements.define('ce-custom-field-select', CustomFieldSelect);
})();
